import {userConstants} from '../_constants';

export function userBalance(state = {}, action) {
  switch (action.type) {
    case userConstants.LOGIN_SUCCESS:
      return {};
    case userConstants.USER_BALANCE_REQUEST:
      return {
        loading: true,
      };
    case userConstants.USER_BALANCE_SUCCESS:
      return {
        ...action.data,
      };
    case userConstants.USER_BALANCE_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
